import { render, staticRenderFns } from "./CarType.vue?vue&type=template&id=04b1540c&scoped=true"
import script from "./CarType.vue?vue&type=script&lang=js"
export * from "./CarType.vue?vue&type=script&lang=js"
import style0 from "./CarType.vue?vue&type=style&index=0&id=04b1540c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b1540c",
  null
  
)

export default component.exports